const basePath = '/parkplus-store';

const parkplusStoreV2RedirectionRoutes = {
  home: basePath,
  pdp: `${basePath}/`,
  cart: `${basePath}/cart`,
  search: `${basePath}/search`,
  listing: `${basePath}/product-listing`,
  fillCart: `${basePath}/fill-cart`,
  buyFuel: '/parkplus-fuel/buy',
  instantPetrol: `${basePath}/instant-petrol`,
  fuelBarrel: `/services/earn-petrol`,
};

export default parkplusStoreV2RedirectionRoutes;
